<template>
  <div>
    <van-nav-bar
      title="门店备货单管理"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-col :span="24" v-if="userInfo.source_ids">
      <base-select v-model="queryCondition.source_id" label="来源" :options="queryCondition.sourceList" />
    </van-col>
    <van-col :span="24" @click="showSearchListOfClient = true" v-else>
      <base-input v-model="queryCondition.source_name" label="来源" readonly />
    </van-col>
    <van-popup v-model="showSearchListOfClient" :style="{ height: '60%' }" position="bottom">
      <base-search-client-list @change="onConfirmOfSelectClient" />
    </van-popup>
    <van-col :span="24">
      <base-input v-model="queryCondition.code" label="单号" />
    </van-col>
    <van-col :span="24">
      <base-datetime v-model="queryCondition.begin_order_date" label="订单起始" />
    </van-col>
    <van-col :span="24">
      <base-datetime v-model="queryCondition.end_order_date" label="订单截止" />
    </van-col>
    <van-col :span="24">
      <van-col :span="18" style="padding-left: 10px;">
        <span class="err-msg">修改请联系中转库房！</span>
      </van-col>
      <van-col :span="6" style="text-align: right; padding-right: 10px;">
        <base-button @click="query">查询</base-button>
      </van-col>
    </van-col>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-cell>
            <van-panel v-for="row in data" :key="row.id" :title="row.code" :desc="'送货时间：' + row.delivery_time"
                       :status="CONST.REQUIRE_ORDER_STATUS.find(status => status.id === row.status).name">
              <div>
                <van-row>
                  <van-col :span="12" style="font-weight: bold;">
                    ￥{{ row.total_amount | toThousandFilter }}
                  </van-col>
                </van-row>
              </div>
              <div slot="footer">
                <van-row>
                  <van-col :span="24" style="text-align: right; padding-right: 10px;">
                    <base-button type="warning" @click="handleDetails(row)">详情</base-button>&nbsp;
                    <base-button type="default" @click="handleModify(row)">修改</base-button>&nbsp;
                    <base-button @click="handleReceive(row)">接收</base-button>&nbsp;
                    <base-button type="danger" @click="handleDelete(row)">删除</base-button>
                  </van-col>
                </van-row>
              </div>
            </van-panel>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-popup
        v-model="showForm"
        closeable
        close-icon="close"
        position="center"
        :style="{ width: '90%' }"
      >
        <van-col :span="24" style="text-align: center; margin-top: 20px;">
          订单信息
        </van-col>
        <van-col :span="24" v-if="selectedRow">
          <base-input v-model="selectedRow.order_date" label="订单时间" readonly />
          <base-input v-model="selectedRow.code" label="订单号" readonly />
          <base-input v-model="selectedRow.orderer" label="订单来源" readonly />
          <base-input v-model="selectedRow.status_name" label="状态" readonly />
          <van-col :span="24" v-for="(detail, index) in selectedRow.details" :key="detail.key">
            <van-card :num="detail.count" :price="detail.price" :desc="detail.goods_name" :title="'产品' + (index + 1)"
                      thumb="https://img.yzcdn.cn/vant/ipad.jpeg">
              <div slot="tags">
                <van-tag plain type="danger" v-if="detail.type_name">{{ detail.type_name }}</van-tag>
                <van-tag plain type="primary" v-if="detail.specs">{{ detail.specs }}</van-tag>
              </div>
            </van-card>
            <van-col :span="14">
              <base-input-number v-model="detail.amount" label="小计" readonly />
            </van-col>
            <van-col :span="24">
              <base-textarea v-model="detail.remark" label="特殊要求" readonly />
            </van-col>
          </van-col>
          <base-input-number v-model="selectedRow.total_amount" label="原价" readonly />
          <base-textarea v-model="selectedRow.remark" label="备注" readonly />
          <base-input v-model="selectedRow.delivery_time" label="送货时间" readonly />
          <base-input v-model="selectedRow.create_name" label="创建人" readonly />
        </van-col>
      </van-popup>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRequireOrderList, receiveRequireOrder, deleteRequireOrder } from '@/api/require/order'
export default {
  name: 'RequireOrderManage',
  data() {
    return {
      data: [],
      showForm: false,
      loading: false,
      finished: false,
      refreshing: false,
      showSearchListOfClient: false,

      selectedRow: null,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        type: this.CONST.ORDER_BILL_TYPES.find(type => type.name === '门店备货单').id,

        begin_order_date: this.Utils.df(null, '{y}-{m}-{d} 00:00:00'),
        end_order_date: this.Utils.df(null, '{y}-{m}-{d} 23:59:59'),
        code: '',
        source_id: null,
        source_ids: '',
        source_name: '',
        sourceList: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.queryCondition.sourceList = []
    const sourceIdList = this.userInfo.source_ids ?
      this.userInfo.source_ids.split(',') : []
    const sourceNameList = this.userInfo.source_names ?
      this.userInfo.source_names.split(',') : []
    for (let i = 0, j = sourceIdList.length; i < j; i++) {
      this.queryCondition.sourceList.push({
        id: parseInt(sourceIdList[i]),
        name: sourceNameList[i]
      })
    }
    if (this.queryCondition.sourceList && this.queryCondition.sourceList.length > 0) {
      this.queryCondition.source_id = parseInt(this.queryCondition.sourceList[0].id)
      this.queryCondition.source_name = this.queryCondition.sourceList[0].name
    }
    this.query()
  },
  methods: {
    query() {
      this.data = []
      this.loading = true
      this.finished = false
      this.refreshing = false
      this.queryCondition.orderer_ids = this.queryCondition.source_id ?
        this.queryCondition.source_id.toString() : ''
      getRequireOrderList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.queryCondition.total = resp.total.count
        this.loading = false
        this.finished = true
      }).catch(error => {
        this.loading = false
        this.finished = true
      })
    },
    handleDetails(row) {
      this.selectedRow = row
      this.selectedRow.status_name = this.CONST.REQUIRE_ORDER_STATUS.find(status => status.id === row.status).name
      this.showForm = true
    },
    handleModify(row) {
      localStorage.setItem('requireOrderFormModel', JSON.stringify(row))
      this.$router.push('/require/order')
    },
    handleReceive(row) {
      this.confirm('确定完成订单收货吗？').then(() => {
        receiveRequireOrder({
          ids: row.id.toString()
        }).then(resp => {
          this.success(resp.msg)
          this.query()
        })
      }).catch(_ => {})
    },
    handleDelete(row) {
      this.confirm('确定删除订单吗？').then(() => {
        deleteRequireOrder({
          id: row.id
        }).then(resp => {
          this.success(resp.msg)
          this.query()
        })
      }).catch(_ => {})
    },
    onConfirmOfSelectClient(client) {
      this.queryCondition.source_name = client.name
      this.queryCondition.source_id = client.id
      this.showSearchListOfClient = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/require/order-manage.vue